import { render, staticRenderFns } from "./science_park.vue?vue&type=template&id=7370f6b4&"
import script from "./science_park.vue?vue&type=script&lang=js&"
export * from "./science_park.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports